import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import { withFieldProps } from 'hooks/useFieldProps';
import Spinner from 'common/Spinner';
import ErrorMsg from 'common/ErrorMsg';
import Help from 'common/Help';
import Tooltip from 'common/Tooltip';

import FlyupLabel from '../common/FlyupLabel';
import rootStyles from './styles/root';
import inputStyles from './styles/input';

const styles = ({ forms, palette, spacing, typography }) => ({
  input: {
    ...inputStyles({ forms, palette, typography }),
    color: palette.form.text,
    cursor: 'not-allowed',
  },
  root: rootStyles({ spacing }),
});

const Output = ({
  classes,
  error,
  fieldDomId,
  help,
  loading,
  name,
  tooltip,
  value,
  valueDescr,
}) => (
  <>
    <div className={classnames('form-group', { error }, classes.root)}>
      <Spinner loading={loading} />
      <FlyupLabel
        fieldName={name}
        error={error}
        value={value}
        focus={false}
        className="touched label-wrap"
        htmlFor={fieldDomId}
        tooltip={tooltip}
        required
      />
      <span className={classnames('output-value', classes.input)}>{valueDescr || value}</span>
      <Tooltip tooltip={tooltip} labeledBy={`label-${fieldDomId}`} />
      <Help help={help} />
    </div>

    <ErrorMsg name={name} />
  </>
);

Output.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  error: PropTypes.bool.isRequired,
  fieldDomId: PropTypes.string.isRequired,
  help: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueDescr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Output.defaultProps = {
  valueDescr: null,
};

const OutputStyled = withStyles(styles)(Output);

const mapStateToProps = ({ fields }, { name }) => {
  const field = fields[name];
  return {
    valueDescr: field.valueDescr,
  };
};

export default withFieldProps(mapStateToProps)(OutputStyled);
